import { axiosClient } from './apiClient'

//============================================================================//
//============================ user api start=================================//
//============================================================================//

export function login(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/login-trainer', data)
}

export function logoutAdmin(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/logout-trainer', data)
}

export function forgotPassword(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/forget-password', data)
}

export function resendNewOtp(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/resend-otp', data)
}

export function otpVerification(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/verify-otp', data)
}

export function resetPassword(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/create-new-password', data)
}

export function changePassword(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/change-password', data)
}

// export function getProfile(data) {
//   return axiosClient.post('/api/v1/admin/auth/get-profile', data)
// }

export function editProfile(data) {
  return axiosClient.post('/lea-training/v1/trainer/auth/edit-profile', data)
}


//============================================================================//
//============================ user api end  =================================//
//============================================================================//


//============================ dashboard api start=================================//

export function dashboard(data) {
  return axiosClient.post('/lea-training/v1/trainer/dashboard/trainer-dashboard', data)
}

export function countryList(data) {
  return axiosClient.post('/lea-training/v1/admin/dashboard/country-list', data)
}

export function cityList(data) {
  return axiosClient.post('/lea-training/v1/admin/dashboard/city-list', data)
}

//============================ dashboard api end  =================================//

//============================ User modules api start=================================//

export function userList(data) {
  return axiosClient.post('/lea-training/v1/admin/user/user-list', data)
}

export function addSingleUser(data) {
  return axiosClient.post('/lea-training/v1/admin/user/add-user', data)
}

export function addBulkUser(data) {
  return axiosClient.post('/lea-training/v1/admin/user/add-bulk-users', data)
}

export function updateSingleUser(data) {
  return axiosClient.post('/lea-training/v1/admin/user/update-user', data)
}
export function deleteSingleUser(data) {
  return axiosClient.post('/lea-training/v1/admin/user/delete-user', data)
}

export function changeSingleUserStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/user/change-user-status', data)
}

//============================ User modules api end  =================================//

//============================ Trainer modules api start=================================//

export function trainerList(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/trainer-list', data)
}

export function addSingleTrainer(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/add-single-trainer', data)
}

export function addBulkTrainer(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/add-bulk-trainers', data)
}

export function updateSingleTrainer(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/update-trainer', data)
}
export function deleteSingleTrainer(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/delete-trainer', data)
}

export function changeSingleTrainerStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/change-trainer-status', data)
}

export function myReviewList(data) {
  return axiosClient.post('/lea-training/v1/admin/trainer/trainer-review-list', data)
}

//============================ Trainer modules api end  =================================//
//============================ Category modules api start=================================//

export function categoryList(data) {
  return axiosClient.post('/lea-training/v1/admin/category/category-list', data)
}

export function addSingleCategory(data) {
  return axiosClient.post('/lea-training/v1/admin/category/add-category', data)
}

export function updateSingleCategory(data) {
  return axiosClient.post('/lea-training/v1/admin/category/update-category', data)
}
export function deleteSingleCategory(data) {
  return axiosClient.post('/lea-training/v1/admin/category/delete-category', data)
}

export function changeSingleCategoryStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/category/change-category-status', data)
}

//============================ Category modules api end  =================================//
//============================ Course modules api start=================================//

export function courseList(data) {
  return axiosClient.post('/lea-training/v1/admin/course/trainer-assign-course-list', data)
}

export function addSingleCourse(data) {
  return axiosClient.post('/lea-training/v1/admin/course/add-course', data)
}

export function updateSingleCourse(data) {
  return axiosClient.post('/lea-training/v1/admin/course/update-course', data)
}
export function deleteSingleCourse(data) {
  return axiosClient.post('/lea-training/v1/admin/course/delete-course', data)
}

export function changeSingleCourseStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/course/change-course-status', data)
}

export function lessionList(data) {
  return axiosClient.post('/lea-training/v1/admin/course/lession-list', data)
}

export function addSingleLession(data) {
  return axiosClient.post('/lea-training/v1/admin/course/add-lession', data)
}

export function updateSingleLession(data) {
  return axiosClient.post('/lea-training/v1/admin/course/update-lession', data)
}
export function deleteSingleLession(data) {
  return axiosClient.post('/lea-training/v1/admin/course/delete-lession', data)
}

export function changeSingleLessionStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/course/change-lession-status', data)
}

export function enrollUserList(data) {
  return axiosClient.post('/lea-training/v1/admin/course/enroll-course-users', data)
}

export function courseReviewList(data) {
  return axiosClient.post('/lea-training/v1/admin/course/course-review-list', data)
}
//============================ Course modules api end  =================================//
//============================ Test modules api start=================================//

export function testList(data) {
  return axiosClient.post('/lea-training/v1/admin/test/test-list', data)
}

export function addSingleTest(data) {
  return axiosClient.post('/lea-training/v1/admin/test/add-test', data)
}

export function updateSingleTest(data) {
  return axiosClient.post('/lea-training/v1/admin/test/update-test', data)
}
export function deleteSingleTest(data) {
  return axiosClient.post('/lea-training/v1/admin/test/delete-test', data)
}

export function changeSingleTestStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/test/change-test-status', data)
}

export function questionList(data) {
  return axiosClient.post('/lea-training/v1/admin/test/question-list', data)
}

export function addSingleQuestion(data) {
  return axiosClient.post('/lea-training/v1/admin/test/add-single-question', data)
}

export function addBulkQuestion(data) {
  return axiosClient.post('/lea-training/v1/admin/test/add-bulk-question', data)
}

export function updateSingleQuestion(data) {
  return axiosClient.post('/lea-training/v1/admin/test/update-question', data)
}

export function deleteSingleQuestion(data) {
  return axiosClient.post('/lea-training/v1/admin/test/delete-question', data)
}

export function deleteBulkQuestion(data) {
  return axiosClient.post('/lea-training/v1/admin/test/delete-bulk-question', data)
}

export function changeSingleQuestionStatus(data) {
  return axiosClient.post('/lea-training/v1/admin/test/change-question-status', data)
}

export function attemptUserList(data) {
  return axiosClient.post('/lea-training/v1/admin/test/test-attempt-users', data)
}
//============================ Test modules api end  =================================//
//============================ CommunityForum modules api start=================================//

export function communityForumList(data) {
  return axiosClient.post('/lea-training/v1/trainer/community-forum/community-forum-list', data)
}

export function communityForumAnswerList(data) {
  return axiosClient.post('/lea-training/v1/trainer/community-forum/community-forum-answer-list', data)
}

export function addSingleCommunityForumAnswer(data) {
  return axiosClient.post('/lea-training/v1/trainer/community-forum/add-coomunity-forum-answer', data)
}

export function updateSingleCorrectAnswer(data) {
  return axiosClient.post('/lea-training/v1/trainer/community-forum/update-correct-answer', data)
}

export function blogList(data) {
  return axiosClient.post('/lea-training/v1/trainer/community-forum/blog-list', data)
}

//============================ CommunityForum modules api end  =================================//
//============================ CMS modules api start=================================//

export function cmsList(data) {
  return axiosClient.post('/lea-training/v1/admin/cms/cms-list', data)
}

export function faqList(data) {
  return axiosClient.post('/lea-training/v1/admin/cms/faq-list', data)
}


//============================ CMS modules api end  =================================//



//============================ chat module api start=================================//

export function recentChatList(data) {
  return axiosClient.post('/lea-training/v1/chat/recent_chat_list', data)
}

export function personalChatList(data) {
  return axiosClient.post('/lea-training/v1/chat/personal_chat_list', data)
}

//============================ chat module api end=================================//


//============================ Language modules api start=================================//

export function languageList(data) {
  return axiosClient.post('/lea-training/v1/admin/language/language-list', data)
}

//============================ Language modules api end  =================================//
export function uploadS3(data) {
  return axiosClient.post(`/lea-training/v1/s3-client/upload-image`, data);
}